module.exports = __webpack_public_path__ + "files/33f225b8f5f7d6b34a0926f58f96c1e9.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600.ttf
// module id = 1360
// module chunks = 59